module.exports = __webpack_public_path__ + "img/investment.75fb84a8.svg";